import React, { useEffect, useState, useRef } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel3";
import benefiticon from "../../assets/images/Benefits icon 1 (1).webp"

const services = [
  {
    id: 1,
    title: "Increased Website Traffic",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
    content1:
      "Higher rankings mean more organic visitors to your website, reducing the need for paid ads.",
  },
  {
    id: 2,
    title: "Better Lead Generation  & Sales",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
    content1:
      "SEO helps attract targeted users who are actively searching for your products or services.",
  },
  {
    id: 3,
    title: "  Long-Term Marketing  Investment",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
    content1:
      "Unlike paid ads, SEO provides sustainable results over time, making it cost-effective.",
  },
  {
    id: 4,
    title: "Brand Credibility & Trust",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
    content1:
      "Websites that appear on the first page of Google are seen as more trustworthy by users.",
  },
  {
    id: 5,
    title: " Competitive Advantage",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
    content1:
      "Ranking above competitors gives your business greater online visibility and market share.",
  },
  {
    id: 6,
    title: "Better User Experience (UX)",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
    content1:
      "SEO improves website speed, mobile usability, and navigation, leading to higher engagement.",
  },
];
const DigitalSeoAni = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = useRef([]);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px 0px -60% 0px", // triggers earlier when top is at 40% of viewport
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = Number(entry.target.getAttribute("data-index"));
          setActiveIndex(index);
        }
      });
    }, options);

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      sectionRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  return (
    <div>
      <div className="">
        <div className="benefitsfont">benefits</div>
        <div className="benefithead">SEO Ads</div>
        <div className="mb-5">
                       <div className="container-fluid">
                         <div className="row">
                           <div className="col-lg-12">
                             <div className="benefitwidth">
                               <OwlCarousel
                                 className="owl-theme"
                                 loop
                                 autoplay={true}
                                 items="1"
                                 dots={false}
                                 smartSpeed={2000}
                                 nav={true}
                                 navText={[
                                   `<i class="fa fa-chevron-left"></i>`,
                                   `<i class="fa fa-chevron-right"></i>`,
                                 ]}
                                 margin={20}
                                 // center={true}
                                 autoplayTimeout={5000}
                                 responsive={{
                                   360: {
                                     items: "1",
                                   },
                                   414: {
                                     items: "1",
                                   },
                                   670: {
                                     items: "2",
                                   },
                                   992: {
                                     items: "3",
                                   },
         
                                   1200: {
                                     items: "3",
                                   },
                                 }}
                               >
                                 {services.map((item, index) => {
                                   return (
                                    <div className="position-circle">
                                       <img  src={benefiticon} className='benefiticon' alt='icon'/>
                                       <div className="border-dot1">
                                    <div className="orange-circle">
          
                                    </div>
                                    </div>
                                    <div className="carousel-wapp-card">
                                     
    <div>
      <div className="carouselwapp">
    {item.title}
      </div>
      <div className="carousel-para">
    {item.content1}
      </div>
    </div>
    
                                    </div>
                                    </div>
                                    
                                   );
                                 })}
                               </OwlCarousel>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
      </div>
    </div>
  );
};

export default DigitalSeoAni;
